import { Component, OnInit, ViewChild, HostListener, ViewChildren, QueryList } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CryptoService } from '../crypto.service';
import { CaesarComponent } from '../caesar/caesar.component';
import { letterFrequencies, trigramFrequencies, bigramFrequencies } from '../../../assets/constant';
import { InputFieldComponent } from '../input-field/input-field.component';
import { CryptoView } from '../crypto-view';
import { SkytaleComponent } from '../skytale/skytale.component';
import { MonoalphabeticComponent } from '../monoalphabetic/monoalphabetic.component';
import { BarVertical2DComponent } from '@swimlane/ngx-charts';




@Component({
  selector: 'app-decode-without-key',
  templateUrl: './decode-without-key.component.html',
  styleUrls: ['../topic-style.css', './decode-without-key.component.css']
})

export class DecodeWithoutKeyComponent extends GeneralExerciseComponent {

  @ViewChild('caesar', {static: true})
  private caesar: CaesarComponent;

  @ViewChild('skytale', {static: true})
  private skytale: SkytaleComponent;

  @ViewChild('monoalphabetic', {static: true})
  private monoalphabetic: MonoalphabeticComponent;

  private view: CryptoView;

  @ViewChildren(BarVertical2DComponent) chart: QueryList<BarVertical2DComponent>;

  @ViewChild('inputField', {static: true})
  private inputField: InputFieldComponent;

  plainText: string;
  cipherText: string;
  method: string;
  keyP: any;
  keyStudent: any;
  modus: string;
  hints: string[];
  showStats: boolean;
  showBigrams: boolean;
  showTrigrams: boolean;
  decodeAutomatically: boolean;

  language: string;

  frequency: any[] = [];
  bigrams: any[] = [];
  trigrams: any[] = [];

  dCipherText: string[];
  dPlainText: string[];

  caretPos: number = 0;
  positionLetter: string;

  errors: number[] = [];

  standardFrequencies = letterFrequencies;
  trigramFrequencies = trigramFrequencies;
  bigramFrequencies = bigramFrequencies;

  dataFrequencies: any[] = [];
  dataBigram: any[] = [];
  dataTrigram: any[] = [];

  selected = 0;



  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected cryptoService: CryptoService) {
    super(activatedRoute, topicService, messageService);
    this.type = "decodeWithoutKey";
  }

  setTypeSpecificsFromConfiguration() {
    this.cipherText = this.configuration.typespecifics.text;
    this.dCipherText = this.cipherText.split("");
    this.method = this.configuration.typespecifics.method;
    this.keyStudent = undefined;
    if (this.view) {
      this.view.resetmapping();
    }
    this.keyP = this.configuration.typespecifics.key;
    this.plainText = this.cryptoService.decode(this.method, this.keyP, this.cipherText).replace(/-/gi, " ").replace(/[A-z]/gi, "#");
    this.modus = this.configuration.typespecifics.modus;
    this.showStats = this.configuration.typespecifics.showStats;
    this.showBigrams = this.configuration.typespecifics.showBigrams;
    this.showTrigrams = this.configuration.typespecifics.showTrigrams;
    this.decodeAutomatically = this.configuration.typespecifics.decodeAutomatically;
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
    }
    this.caretPos = 0;
    while (this.cipherText.charAt(this.caretPos) === " ") {
      this.caretPos++;
    }
    this.onEmit(this.caretPos);

    let temphints = this.configuration.typespecifics.hints;
    this.hints = [];
    for (let hint of temphints) {
      this.hints[this.cryptoService.encode(this.method, this.keyP, hint).charCodeAt(0) - 65] = hint;
    }
    this.view.setHints(this.hints);
    this.cryptoService.computefrequencies(this.frequency, this.bigrams, this.trigrams, this.cipherText);

    // copute the frequencies
    this.language = this.topicService.getLanguage();
    this.dataFrequencies = [];
    let index = 0;
    for (let c of this.standardFrequencies[this.language]) {
      this.dataFrequencies.push({
        name: c.key.concat(" ", this.frequency[index].key),
        series: [
          {
            name: this.get("standardFrequencies"),
            value: +c.value
          },
          {
            name: this.get("cipherFrequencies"),
            value: this.frequency[index].value
          }
        ]
      });
      index++;
    }
    this.dataBigram = [];
    index = 0;
    for (let c of this.bigramFrequencies[this.language]) {
      this.dataBigram.push({
        name: c.key.concat(" ", this.bigrams[index].key),
        series: [
          {
            name: this.get("standardFrequencies"),
            value: +c.value
          },
          {
            name: this.get("cipherFrequencies"),
            value: this.bigrams[index].value
          }
        ]
      });
      index++;
    }
    this.dataTrigram = [];
    index = 0;
    for (let c of this.trigramFrequencies[this.language]) {
      this.dataTrigram.push({
        name: c.key.concat(" ", this.trigrams[index].key),
        series: [
          {
            name: this.get("standardFrequencies"),
            value: +c.value
          },
          {
            name: this.get("cipherFrequencies"),
            value: this.trigrams[index].value
          }
        ]
      });
      index++;
    }


    if (this.method == "monoalphabetic") {
      this.changeMonoalphabeticKey(this.view.getMapping());
    }

    
    this.printable = (this.method != "skytale");

  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.plainText) {
        this.plainText = this.state.typespecific.plainText;
      }
      if (this.state.typespecific.mapping) {
        this.view.setmapping(this.state.typespecific.mapping);
      }
      if (this.state.typespecific.keyStudent) {
        this.keyStudent = this.state.typespecific.keyStudent;
      }
    }
  }

  computeState() {
    this.plainText = this.inputField.text;
    this.state.typespecific.plainText = this.plainText;
    this.state.typespecific.keyStudent = this.keyStudent;

    this.state.typespecific.mapping = this.view.getMapping();

  }

  /** when the decoded text changes, recompute the highlighted letter */
  onEmit(event) {
    this.caretPos = event;
    this.positionLetter = this.cipherText.charAt(this.caretPos);

    if (this.method == "skytale") {
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(event / ((Math.floor(this.plainText.length / this.keyP))));
      while (this.plainText.charAt(this.caretPos) === " ") {
        this.caretPos--;
      }
    }
  }

  checkSolution() {
    if (this.keyStudent != this.keyP) {
      if (this.method != "monoalphabetic") {
        this.messageService.addAlertWithTimeout(this.get("wrongKey"), "danger", 10000);
      } else {
        let keyError = false;
        for (let i = 0; i < 26; i++) {
          console.log(this.keyStudent.charAt(i) + this.cryptoService.decode(this.method, this.keyP, String.fromCharCode(i + 65)) + this.cryptoService.encode(this.method, this.keyStudent, String.fromCharCode(i + 65)))
          if (this.cipherText.includes(String.fromCharCode(i + 65)) && this.cryptoService.decode(this.method, this.keyP, String.fromCharCode(i + 65)) != this.cryptoService.encode(this.method, this.keyStudent, String.fromCharCode(i + 65))) {
            keyError = true;
          }
        }
        if (keyError) {
          this.messageService.addAlertWithTimeout(this.get("wrongKey"), "danger", 10000);
        }
      }
    }
    let solution = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
    this.plainText = this.inputField.text;
    this.errors = solution.split("").map((v, i) => [v, this.plainText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    if (this.method == "skytale") {
      this.errors = this.errors.map((v, i) => Math.floor(v % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(v / ((Math.floor(this.plainText.length / this.keyP)))));
    }
    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("notCorrectlyDecoded"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correctlyDecoded"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    let result = [0, 0];
    if (this.method == "caesar" || this.method == "skytale") {
      if (this.keyStudent == this.keyP) {
        result = [1, 1];
      } else {
        result = [0, 1];
      }
    } else {
      let keyError = 0;
      let keySum = 0;
      for (let i = 0; i < 26; i++) {
        console.log(this.keyStudent.charAt(i) + this.cryptoService.decode(this.method, this.keyP, String.fromCharCode(i + 65)) + this.cryptoService.encode(this.method, this.keyStudent, String.fromCharCode(i + 65)))
        if (this.cipherText.includes(String.fromCharCode(i + 65))){
          keySum ++;
          if (this.cryptoService.decode(this.method, this.keyP, String.fromCharCode(i + 65)) != this.cryptoService.encode(this.method, this.keyStudent, String.fromCharCode(i + 65))) {
            keyError++;
          }
        }
      }
      result= [(keySum -keyError)/keySum * 3, 3]
    }
    if (!this.decodeAutomatically && this.method != "monoalphabetic") {
      let solution = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
      this.plainText = this.inputField.text;
      let errors = solution.split("").map((v, i) => [v, this.plainText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
      let result0 = (this.plainText.length - errors.length) / 20;
      let result1 = this.plainText.length / 20;
      if (this.modus == 'highlight') {
        result0 = result0 / 2;
        result1 = result1 / 2;
      }
      result[0] += result0;
      result[1] += result1;
    }
    return result;
  }

  /** decode the text based on the mapping */
  decode() {
    if (this.decodeAutomatically) {
      this.plainText = this.cryptoService.decode(this.method, this.keyStudent, this.cipherText);
    }
  }

  /** when the monoalphabetic key changes, compute the plaintext */
  changeMonoalphabeticKey(key: any) {
    if (this.method == "monoalphabetic") {
      this.keyStudent = key;
      this.plainText = this.cipherText.split("").map(v => (v === " ") ? v : this.keyStudent.charAt(v.charCodeAt(0) - 65) == " " ? "#" : this.keyStudent.charAt(v.charCodeAt(0) - 65)).join("");
      this.inputField.text = this.plainText;
    }
  }

  /** compute the key based on the new input */
  fillKey(input: string[]) {
    let mapping = this.view.getMapping();
    let cipher = this.cipherText.charAt(+input[1]);
    let plain = this.cryptoService.normalizeText(input[0]);
    mapping = mapping.split("");
    if (plain == "#") {
      mapping[input[0].charCodeAt(0) - 65] = " ";
    } else {
      mapping[cipher.charCodeAt(0) - 65] = plain;
    }
    this.view.setmapping(mapping.join(""));
    this.changeMonoalphabeticKey(this.view.getMapping());
  }

  /** returns the correct method description */
  getMethodDescription() {
    switch (this.method) {
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }

  }

  preprint() {
    if (this.modus == "highlight") {
      this.modus = "normal";
    }
  }

  postprint() {
    this.modus = this.configuration.typespecifics.modus;
  }

}
